import { render } from "./FormInputTextarea.vue?vue&type=template&id=fc9d3174"
import script from "./FormInputTextarea.vue?vue&type=script&lang=js"
export * from "./FormInputTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__